<template>
  <div class="download-links">
    <div>
      <a
        :href="imageUrls.MediumImageUrl"
        @click="trackClick('Medium')"
      >
        <contentful-text :item="contentfulText('checkout-download-photos-image-size-medium')" />
      </a>
    </div>
    <div v-if="showLargeXLargePhotoLinks">
      <a
        v-if="productPart.HaveFull"
        :href="imageUrls.LargeImageUrl"
        @click="trackClick('Large')"
      >
        <contentful-text :item="contentfulText('checkout-download-photos-image-size-large')" />
      </a>
      <div
        v-if="!productPart.HaveFull"
        class="download-links__not-ready"
      >
        <contentful-text :item="contentfulText('checkout-download-photos-image-size-large')" />
      </div>
      <div v-if="viewModel.AllowXLarge">
        <a
          v-if="productPart.HaveFull"
          :href="imageUrls.XLargeImageUrl"
          @click="trackClick('XLarge')"
        >
          <contentful-text :item="contentfulText('checkout-download-photos-image-size-xlarge')" />
        </a>
        <div
          v-if="!productPart.HaveFull"
          class="download-links__not-ready"
        >
          <contentful-text :item="contentfulText('checkout-download-photos-image-size-xlarge')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'DownloadLinks',
  props: {
    productPart: { type: Object, default: null, required: true },
    imageUrls: { type: Object, default: null, required: true }
  },
  computed: {
    viewModel () {
      return this.$store.state.viewModel
    },
    content () {
      return this.viewModel.PageContent
    },
    showLargeXLargePhotoLinks () {
      return this.viewModel.FullSizedDownloadEntitled && this.viewModel.IsTLHAvailable
    }
  },
  methods: {
    trackClick (size) {
      GoogleAnalytics.trackEvent(
        'DigitalImageDownload',
        'Image',
        size
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.download-links {
  text-align: center;

  &__not-ready {
    text-align: center;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/Photos/DownloadLinks.vue